import catalog from './command-catalog.json';
export const COMMAND_CATALOG = catalog;
export const PILOT_HELP = COMMAND_CATALOG.map((c) => `${c.title}: ID ${c.syntax} — “${c.spoken}”. ${c.when}`).join('\n');
